import React from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 90%;
  margin: 5% 10% 5% 10%;
  display: flex;
  justify-content: space-between;
`;

const CVWrapper = styled.div`
  width: 70%;
  height: 70vh;
`;

const CV = () => {
  return (
    <Container>
      <CVWrapper>
        <embed
          src="./files/BillingsCV.pdf"
          type="application/pdf"
          width="100%"
          height="100%"
          title="Embedded PDF Viewer"
        />
      </CVWrapper>
    </Container>
  );
};

export default CV;
